import React, { useState } from "react";
import { translate } from "../../i18n";
import { connect } from "../../redux";
import { PARTICIPANT_STATUS, PERMISSION, ROLE } from "../constants";

import { useEffect } from "react";
import { MdBackHand, MdMic, MdMoreHoriz, MdVideocam } from "react-icons/md";
import { checkIsOpenedGroup, getGroupName, getStartGroup } from "../../../group";
import { NOTIFICATION_TIMEOUT, showNotification } from "../../../notifications";
import { muteLocal, muteRemote } from "../../../video-menu";
import { isCheckPermission } from "../../localuser";
import { MEDIA_TYPE } from "../../media";
import { isRemoteTrackMuted } from "../../tracks";
import { participantRoleChanged } from "../actions";
import { checkRoleLevel, isParticipantModerator } from "../function";
import { IconStyled } from "../style";
import PinnedParticipant from "./PinnedParticipant";
import { getGroupId } from "../../conference";

const CHANGE_ROLE_LIST = [ROLE.MANAGER, ROLE.PRESENTER, ROLE.PARTICIPANT];

function ParticipantItem({
    t, dispatch, isLocalHost, hover = true, currentGropuId, groupStart,
    isLocal, isHost, isAttend, isVideoMuted, isAudioMuted,
    user_uuid, role, nickname, pinned, group_name, status,
    isPinPermission, iskickPermission, isMRolePermission, isMCameraPermission, isMMicPermission
}) {
    if (!user_uuid) return null;
    const [ control, setControl ] = useState(false);
    
    const handPermission = APP.layout.participant.handler && ((isLocalHost && !isLocal) || (!isLocalHost && isLocal));
    const { video: videoPermission, mic: micPermission, kick: kickPermission, changeRole: rolePermission, allPermission: allPermission } = APP.layout.participant;

    useEffect(() => {
        setControl(false);
    }, [groupStart, currentGropuId]);

    const sendRaiseHand = () => {
        if (!hover) return;
        if (isLocal === false && isLocalHost) {
            let changeRole = ROLE.PARTICIPANT;
            if (role !== ROLE.PRESENTER) changeRole = ROLE.PRESENTER;

            dispatch(participantRoleChanged(user_uuid, changeRole));
            APP.mateManagement.setParticipantRole(changeRole, user_uuid);
            return;
        }

        if (role === ROLE.PRESENTER) return;
        
        dispatch(showNotification({titleKey: 'notify.requestPresentation', isRequestPresent: true, isMe: true}, NOTIFICATION_TIMEOUT));
        APP.mateManagement.raiseHand();
    }
    const setVideoMuted = () => {
        if (!hover) return;
        if (isLocal) {
            APP.UI.toggleVideo(!isVideoMuted);
            return;
        } 

        if (!isMCameraPermission) return;
        dispatch(muteRemote(user_uuid, MEDIA_TYPE.VIDEO, !isVideoMuted));
    }

    const setAideoMuted = () => {
        if (!hover) return;
        if (isLocal) {
            dispatch(muteLocal(!isAudioMuted, MEDIA_TYPE.AUDIO));
            return;
        } 

        if (!isMMicPermission) return;
        dispatch(muteRemote(user_uuid, MEDIA_TYPE.AUDIO, !isAudioMuted));
    }

    const handlerKickUser = e => {
        setControl(false); 
        if (!hover) return;

        const viewWindow = e.view.window || window;
        if (viewWindow.confirm( t("chat.confirmKickUser", { nickname }) )) {
            APP.mateManagement.kickParticipant(user_uuid);
        }
    }

    const handlerChangeRole = (role) => {
        if (!hover) return;
        
        APP.mateManagement.setParticipantRole(role, user_uuid);
        setControl(false);   
    };

    return (
        <div className={`item_participant item_${isLocal} nonSelect`}>
            <ul>
                <li className="role">{ t(`role.${role}`) }</li>
                <li className="nickname">
                    <span className="overText">{nickname}</span>
                    { isLocal && t("notify.me") } 
                </li>
                { isAttend === false ? <li style={{ color: "red", width: "30%" }}>  <span className="overText">{ status === PARTICIPANT_STATUS.VACATED ? "미 참 석" :  group_name } </span></li> :
                    <li>
                        { handPermission && 
                            <IconStyled className="pinIcon" isPointer={hover && handPermission} isOn={role === ROLE.PRESENTER} onClick={sendRaiseHand} >
                                <MdBackHand />
                            </IconStyled> }

                        { hover && <PinnedParticipant hover={hover} pinLayoutMode={false} pinned={pinned} participantId={user_uuid} hidePinLayout={APP.layout.participant.pin} />}

                        { videoPermission && 
                            <IconStyled className="icon" isPointer={hover && (isLocal || isMCameraPermission)} isOn={isVideoMuted} onClick={setVideoMuted}> 
                                <MdVideocam />
                            </IconStyled> }

                        { micPermission && 
                            <IconStyled className="icon" isPointer={hover && (isLocal || isMMicPermission)} isOn={isAudioMuted} onClick={setAideoMuted}>
                                <MdMic />
                            </IconStyled> }
                        
                        { hover && (kickPermission || rolePermission) && !isLocal && iskickPermission && isMRolePermission && 
                            <IconStyled className="icon" isPointer={true} isOn={!control} onClick={() => {setControl(!control) }}>
                                <MdMoreHoriz />
                            </IconStyled> }
                    </li> 
                }
            </ul>
            { control && <div className="control control_true nonSelect">
                { allPermission && isMRolePermission && 
                    CHANGE_ROLE_LIST.map((r, index) => ( <span key={index} onClick={() => handlerChangeRole(r)}>{ t(`role.${r}`) }</span> ))}                    
            
                { kickPermission && iskickPermission && 
                    <span onClick={handlerKickUser}>
                        { t("chat.kick") }
                    </span>
                }
                <span onClick={() => setControl(false)}>X</span>
            </div>}
        </div>
    )
}

function _mapStateToProps(state, ownProps) {
    const { participant } = ownProps;
    if (participant) {   
        const currentGropuId = getGroupId(state);
        const groupStart = getStartGroup(state);  
        const { local: isLocal, user_uuid, nickname, role, pinned, status, group_id } = participant;

        const isShow = isLocal ? true : checkIsOpenedGroup(state, group_id);
        const group_name = getGroupName(state, group_id);
        const isHost = isParticipantModerator(state, user_uuid);
        const isAttend = status === PARTICIPANT_STATUS.OCCUPIDE && isShow ? true : false;

        const isVideoMuted = isRemoteTrackMuted(state, MEDIA_TYPE.VIDEO, isLocal ? "local" : user_uuid);
        const isAudioMuted = isRemoteTrackMuted(state, MEDIA_TYPE.AUDIO, isLocal ? "local" : user_uuid);
            
        return {
            groupStart, currentGropuId,
            isLocal, isHost, isAttend, isVideoMuted, isAudioMuted,
            user_uuid, role, nickname, pinned, group_name, status,
            isPinPermission: isCheckPermission(state, PERMISSION.PIN),
            iskickPermission: isCheckPermission(state, PERMISSION.KICK) && checkRoleLevel(state, role),
            isMRolePermission: isCheckPermission(state, PERMISSION.MEMBER_ROLE),
            isMCameraPermission: isCheckPermission(state, PERMISSION.MEMBER_CAMERA),
            isMMicPermission: isCheckPermission(state, PERMISSION.MEMBER_MIC)
        }
    } else {
        return null;
    }
}

export default translate(connect(_mapStateToProps)(ParticipantItem));